<template>
	<dms-check :indeterminate="isIndeterminate" v-bind="{...$props, ...$attrs}" @update:value="updateValue" />
</template>

<script>
import { BaseInput } from '#components/dms/common/baseInput';

export default BaseInput.extend({
	name: 'Dms3stateCheck',
	props: {
		value: { type: Boolean, default: false },
	},

	computed: {
		isIndeterminate() {
			return this.value === null;
		},
	},

	methods: {
		next(value) {
			switch (value) {
				case false:
					return null;
				case null:
					return true;
				case true:
					return false;
				default:
					return false;
			}
		},

		updateValue() {
			this.$emit('update:value', this.next(this.value));
		},
	},
});
</script>
